import ImageZoom from './ImageZoom';
export default ImageZoom;
